import { render } from "./EditBlog.vue?vue&type=template&id=2894f5a4&scoped=true"
import script from "./EditBlog.vue?vue&type=script&lang=js"
export * from "./EditBlog.vue?vue&type=script&lang=js"

import "./EditBlog.vue?vue&type=style&index=0&id=2894f5a4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2894f5a4"]])

export default __exports__